module.exports = __webpack_public_path__ + "img/dashboard2_g.2f9aa39b.svg";